<template>
    <div>
      <el-form style="margin: 0 30px 0 20px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="服务类型名称" prop="typename" v-if="addEditForm.is_service === 0">
          <el-input v-model="addEditForm.typename" placeholder="请输入服务类型名称"></el-input>
        </el-form-item>
        <el-form-item label="服务内容名称" prop="typename" v-if="addEditForm.is_service === 1">
          <el-input v-model="addEditForm.typename" placeholder="请输入服务内容名称"></el-input>
        </el-form-item>
        <el-form-item label="服务类型级别" v-if="addEditForm.is_service === 0 && moduletag !== 2">
          <el-radio-group :disabled="!isAdd" v-model="islevel" @change="changeLevel">
            <el-radio :label="1">大类</el-radio>
            <el-radio :label="2">小类</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addEditForm.is_service === 0 && islevel !== 1" label="上级类型" prop="upid">
          <el-select v-fixZoom v-model="addEditForm.upid" style="width: 380px;" placeholder="请选择" @change="changeDtype">
            <el-option v-for="item in typeLeve1" :key="item.id" :label="item.typename" :value="item.id"></el-option>
          </el-select>
<!--          <el-cascader v-fixZoom style="width: 100%" :options="typeTree" v-model="addEditForm.upid" :filterable="true" placeholder="请选择上级类型"-->
<!--                       :props="{ checkStrictly: true, value: 'id', label: 'typename', children: 'child', emitPath: false, disabled: 'onEdit'}" ref="typeOptions"-->
<!--                       @change="changeType">-->
<!--            <template #default="{data}">-->
<!--              <span v-if="data.is_service === 1" style="font-style: italic;color: #999999">{{ data.typename}}</span><strong v-else style="color: #1a1a1a;">{{ data.typename}}</strong>-->
<!--            </template>-->
<!--          </el-cascader>-->
        </el-form-item>
        <el-form-item v-if="addEditForm.is_service === 1 && islevel !== 1" label="服务类型" prop="upid">
          <el-cascader v-fixZoom style="width: 100%" :options="typeTree" v-model="addEditForm.upid" :filterable="true" placeholder="请选择服务类型"
                       :props="{ checkStrictly: true, value: 'id', label: 'typename', children: 'child', emitPath: false, disabled: 'onEdit'}" ref="typeOptions"
                       @change="changeType">
            <template #default="{data}">
              <span v-if="data.is_service === 1" style="font-style: italic;color: #999999">{{ data.typename}}</span><strong v-else style="color: #1a1a1a;">{{ data.typename}}</strong>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="服务流程" prop="" v-if="addEditForm.is_service === 1 && islevel !== 1">
          <el-input type="textarea" size="mini" :rows="2" v-model="addEditForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item v-if="islevel === 1 && moduletag !== 2" label="所属组织" prop="orgid">
          <el-cascader v-fixZoom style="width: 100%" :options="treeData" v-model="addEditForm.orgid" :filterable="true" placeholder="请选择所属组织"
            :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}" ref="orgOptions">
          </el-cascader>
        </el-form-item>
        <el-form-item v-if="addEditForm.is_service === 1" label="发起服务扩展字段" prop="">
          <div style="display: flex">
            <div class="btn-add" @click="addService()">+ 添加</div>
            <div style="flex: 1;text-align: right;color: #AFB0B0;font-size: 12px">*此处可设置发起服务需要提供的额外信息</div>
          </div>
          <table class="table-type" v-if="serviceArr.length > 0">
            <tr><th>名称</th><th style="width: 140px;text-align: center">是否必填</th><th style="width: 70px;text-align: center">操作</th></tr>
            <tr v-for="(item, index) in serviceArr" :key="index">
              <td><input class="input" style="width: 100%;" type="text" placeholder="请输入" @blur="blurService(item)" v-model="item.key"/></td>
              <td><el-radio-group v-model="item.required"><el-radio :label="1">是</el-radio><el-radio :label="0">否</el-radio></el-radio-group></td>
              <td style="text-align: center"><i title="移除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delService(index)"></i></td>
            </tr>
          </table>
        </el-form-item>
        <el-form-item v-if="addEditForm.is_service === 1" label="确认服务扩展字段" prop="">
          <div style="display: flex">
            <div class="btn-add" @click="addSure()">+ 添加</div>
            <div style="flex: 1;text-align: right;color: #AFB0B0;font-size: 12px">*此处可设置服务完成后需要填写的额外信息</div>
          </div>
          <table class="table-type" v-if="sureArr.length > 0">
            <tr><th>名称</th><th style="width: 140px;text-align: center">是否必填</th><th style="width: 70px;text-align: center">操作</th></tr>
            <tr v-for="(item, index) in sureArr" :key="index">
              <td><input class="input" style="width: 100%;" type="text" placeholder="请输入" @blur="blurSure(item)" v-model="item.key"/></td>
              <td><el-radio-group v-model="item.required"><el-radio :label="1">是</el-radio><el-radio :label="0">否</el-radio></el-radio-group></td>
              <td style="text-align: center"><i title="移除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delSure(index)"></i></td>
            </tr>
          </table>
        </el-form-item>
        <el-form-item v-if="addEditForm.is_service === 1" label="确认服务照片类型" prop="">
          <div style="display: flex">
            <div class="btn-add" @click="addPicture">+ 添加</div>
            <div style="flex: 1;text-align: right;color: #AFB0B0;font-size: 12px">*此处可设置服务完成后需要上传的照片</div>
          </div>
          <table class="table-type" v-if="pictureArr.length > 0">
            <tr><th>名称</th><th style="width: 140px;text-align: center">是否必填</th><th style="width: 70px;text-align: center">操作</th></tr>
            <tr v-for="(item, index) in pictureArr" :key="index">
              <td><input class="input" style="width: 100%;" type="text" placeholder="请输入" @blur="blurPicture(item)" v-model="item.key"/></td>
              <td><el-radio-group v-model="item.required"><el-radio :label="1">是</el-radio><el-radio :label="0">否</el-radio></el-radio-group></td>
              <td style="text-align: center"><i title="移除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delPicture(index)"></i></td>
            </tr>
          </table>
        </el-form-item>
      </el-form>
      <div>
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeAdd()"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEdit('addEditForm')"><span>确定</span></div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 30px"></div>
    </div>
</template>

<script>
import {addsuppliertype, updatesuppliertype} from '../../../api/serviceMark'
export default {
  name: 'addEditStype',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEdit: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      moduletag: '',
      orgData: [],
      isAdd: true,
      treeData: [],
      types: [],
      typeLeve1: [],
      typeTree: [],
      islevel: 1,
      options: [
        {id: 1, name: '大类'},
        {id: 2, name: '小类'}
      ],
      showUp: true,
      addEditForm: {
        id: '',
        typename: '',
        level: '',
        upid: '',
        orgid: '',
        is_service: 0,
        remark: ''
      },
      addEditRules: {
        typename: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择类型级别', trigger: 'change' }
        ],
        upid: [
          { required: true, message: '请选择上级', trigger: 'change' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ]
      },
      // 发起拓展字段
      serviceArr: [],
      // 确认拓展字段
      sureArr: [],
      pictureArr: []
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.getTypeTree()
    this.getData()
  },
  methods: {
    getLeveOne () {
      let arr = []
      this.types.forEach(item => {
        if (item.is_service === 0 && item.level === 1) {
          arr.push(item)
        }
      })
      this.typeLeve1 = arr
    },
    getData () {
      // console.log(this.addEdit)
      this.orgData = this.addEdit.orgData
      this.isAdd = this.addEdit.isAdd
      this.types = this.addEdit.types
      this.getLeveOne()
      // 所属组织
      let lastLevel = 100
      const arr = this.orgData
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.treeData.push(arr[i])
        }
      }
      for (let i = 0; i < this.treeData.length; i++) {
        const child = this.arrayToNode(arr, this.treeData[i].id)
        if (child.length !== 0) {
          this.treeData[i].child = child
        }
      }
      if (this.isAdd) {
        this.addEditForm.id = 0
        this.addEditForm.is_service = this.addEdit.isService
        this.islevel = 2
      } else {
        this.addEditForm.id = this.addEdit.row.id
        this.addEditForm.typename = this.addEdit.row.typename
        this.addEditForm.level = this.addEdit.row.level
        this.addEditForm.upid = this.addEdit.row.upid
        this.addEditForm.orgid = this.addEdit.row.orgid
        this.addEditForm.is_service = this.addEdit.row.is_service
        this.addEditForm.remark = this.addEdit.row.remark
        if (this.addEditForm.level === 1) {
          this.islevel = 1
        } else {
          this.islevel = 2
        }
        if (this.addEditForm.is_service === 1) {
          if (this.addEdit.row.service_requirements_tag === 1) {
            if (Array.isArray(this.addEdit.row.servicerequirements[0])) {
              this.serviceArr = this.addEdit.row.servicerequirements[0]
            }
            if (Array.isArray(this.addEdit.row.servicerequirements[1])) {
              this.sureArr = this.addEdit.row.servicerequirements[1]
            }
          }
          if (this.addEdit.row.picture_requirements_tag === 1) {
            if (Array.isArray(this.addEdit.row.picturerequirements)) {
              this.pictureArr = this.addEdit.row.picturerequirements
            }
          }
        }
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getTypeTree () {
      // 所属组织
      let lastLevel = 100
      let arr = []
      // console.log(this.addEdit.types)
      for (let i = 0; i < this.addEdit.types.length; i++) {
        let obj = this.addEdit.types[i]
        obj.onEdit = obj.is_service !== 0
        if (obj.level < lastLevel) {
          lastLevel = obj.level
        }
        arr.push(obj)
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.typeTree.push(arr[i])
        }
      }
      for (let i = 0; i < this.typeTree.length; i++) {
        const child = this.arrayToNode1(arr, this.typeTree[i].id)
        if (child.length !== 0) {
          this.typeTree[i].child = child
        }
      }
    },
    // 递归
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.upid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    changeLevel () {
      this.addEditForm.upid = ''
      this.addEditForm.orgid = ''
    },
    changeDtype (id) {
      let obj = ''
      this.types.forEach(item => {
        if (item.id === id) {
          obj = item
        }
      })
      this.addEditForm.level = obj.level + 1
      this.addEditForm.orgid = obj.orgid
      console.log(obj)
    },
    changeType () {
      let obj = this.$refs['typeOptions'].getCheckedNodes()[0].data
      console.log(obj)
      this.addEditForm.level = obj.level + 1
      this.addEditForm.orgid = obj.orgid
    },
    // 发起
    addService () {
      let obj = {key: '', value: '', required: 0}
      this.serviceArr.push(obj)
    },
    blurService (item) {
      let flag = 0
      this.serviceArr.forEach(val => {
        if (val.key === item.key) {
          flag += 1
        }
      })
      if (flag > 1) {
        this.$message({ message: '已有字段，请检查', type: 'warning' })
      }
    },
    delService (index) {
      this.serviceArr.splice(index, 1)
    },
    // 确认
    addSure () {
      let obj = {key: '', value: '', required: 0}
      this.sureArr.push(obj)
    },
    blurSure (item) {
      let flag = 0
      this.sureArr.forEach(val => {
        if (val.key === item.key) {
          flag += 1
        }
      })
      if (flag > 1) {
        this.$message({ message: '已有字段，请检查', type: 'warning' })
      }
    },
    delSure (index) {
      this.sureArr.splice(index, 1)
    },
    addPicture () {
      let obj = {key: '', value: '', required: 0}
      this.pictureArr.push(obj)
    },
    blurPicture (item) {
      let flag = 0
      this.pictureArr.forEach(val => {
        if (val.key === item.key) {
          flag += 1
        }
      })
      if (flag > 1) {
        this.$message({ message: '已有字段，请检查', type: 'warning' })
      }
    },
    delPicture (index) {
      this.pictureArr.splice(index, 1)
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 拓展字段
          let servicerequirementstag = 0
          let servicerequirements = []
          let arr0 = []
          let arr1 = []
          this.serviceArr.forEach(item => {
            if (item.key !== '') {
              let obj = {key: item.key, value: '', required: (item.required || item.required === 0) ? item.required : 0}
              arr0.push(obj)
            }
          })
          if (arr0.length > 0 || arr1.length > 0) {
            servicerequirementstag = 1
          }
          this.sureArr.forEach(item => {
            if (item.key !== '') {
              let obj = {key: item.key, value: '', required: (item.required || item.required === 0) ? item.required : 0}
              arr1.push(obj)
            }
          })
          servicerequirements[0] = arr0
          servicerequirements[1] = arr1
          let picturerequirementstag = 0
          let picturerequirements = []
          this.pictureArr.forEach(item => {
            if (item.key !== '') {
              let obj = {key: item.key, value: '', required: (item.required || item.required === 0) ? item.required : 0}
              picturerequirements.push(obj)
            }
          })
          if (picturerequirements.length > 0) {
            picturerequirementstag = 1
          }
          let data = {
            id: this.addEditForm.id,
            typename: this.addEditForm.typename,
            level: this.addEditForm.level,
            upid: this.addEditForm.upid,
            orgid: this.addEditForm.orgid,
            is_service: this.addEditForm.is_service,
            service_requirements: JSON.stringify(servicerequirements),
            service_requirements_tag: servicerequirementstag,
            picture_requirements: JSON.stringify(picturerequirements),
            picture_requirements_tag: picturerequirementstag,
            remark: this.addEditForm.remark
          }
          if (this.islevel === 1) {
            data.level = 1
            data.upid = 0
          }
          if (this.isAdd) {
            addsuppliertype(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加服务类型',
                type: 'success',
                duration: 2000
              })
              this.$emit('updatetype', {id: res.data.newobjid})
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '添加服务类型失败'
              })
            })
          } else {
            updatesuppliertype(data).then(res => {
              this.$notify({ title: '成功', message: '成功修改服务类型', type: 'success', duration: 2000 })
              this.$emit('updatetype')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({ title: '失败', message: '修改服务类型失败' })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.btn-add{
  width: 58px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #3D83F3;
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3D83F3;
}
.table-type{
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}
.table-type th{
  text-align: left;
  padding-left: 10px;
  box-sizing: border-box;
  height: 30px;
  background: #EBF2FA;
  color: #3D83F3;
  font-size: 14px;
}
.table-type td{
  padding: 5px;
  box-sizing: border-box;
  background: #F3F7FC;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3D3D3D;
}
.input{
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #b3cbee;
  outline: none;
  height: 30px;
  font-size: 14px;
  background: none;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/addEditStype.vue